var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ContentProjection',{attrs:{"type":"article","headline":_vm.headline,"date":_vm.displayArticleDate,"tags":_vm.tags,"page-content":_vm.catalogPageContent,"overview-page-label":_vm.overviewPageLabel,"overview-page-link":_vm.overviewPageLink,"show-in-this-language":_vm.showInThisLanguage,"author":_vm.author}})
}
var staticRenderFns = []

export { render, staticRenderFns }